import { render } from "./ProductVariationBarcodeComponent.vue?vue&type=template&id=35e683e6"
import script from "./ProductVariationBarcodeComponent.vue?vue&type=script&lang=js"
export * from "./ProductVariationBarcodeComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/products/variation/ProductVariationBarcodeComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "35e683e6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('35e683e6', __exports__)) {
    api.reload('35e683e6', __exports__)
  }
  
  module.hot.accept("./ProductVariationBarcodeComponent.vue?vue&type=template&id=35e683e6", () => {
    api.rerender('35e683e6', render)
  })

}


export default __exports__